import { defineRecipe } from '@chakra-ui/react';

export const mark = defineRecipe({
  className: 'chakra-mark',
  base: {
    py: 0.5,
    bg: 'orange.300',
    borderRadius: 'sm',
  },
});
